export const VALIDATION_SHORT_CODE_STORAGE_KEY = '@metropolis/validation:last-used-shortcode';
export const ONBOARDING_UUID_STORAGE_KEY = '@metropolis/onboarding:last-used-uuid';
